import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IS1InputSelectItem } from '@app/s1';
import { StatoAssistenza } from '@app/shared/models/assistenza';
import { UtilityService } from '@app/shared/services/utility.service';

@Component({
  selector: 'ser-stato-assistenza-select',
  templateUrl: './stato-assistenza-select.component.html',
  styleUrl: './stato-assistenza-select.component.scss'
})
export class StatoAssistenzaSelectComponent {

  @Input() control: UntypedFormControl;
  @Input() label: string = "assistenze.fields.stato";
  @Input() readonly: boolean = false;
  @Input() multiple: boolean = false;

  stati: IS1InputSelectItem[];

  constructor(private utils: UtilityService) {
    // Lo stato "Aperto" è stato rimosso dal workflow: non selezionabile come filtro
    this.stati = this.utils.getInputSelectFromEnum(StatoAssistenza).filter(s => s.code != StatoAssistenza.Aperto);
  }

}
